import {LiveStreamCameraLayoutOptions, PlaybackCameraLayoutOptions} from "@models";

export class BaseRecorderLayout {
	public asLiveStreamOptions(options: PlaybackCameraLayoutOptions | LiveStreamCameraLayoutOptions): LiveStreamCameraLayoutOptions {
		return options as LiveStreamCameraLayoutOptions;
	}

	public asPlaybackOptions(options: PlaybackCameraLayoutOptions | LiveStreamCameraLayoutOptions): PlaybackCameraLayoutOptions {
		return options as PlaybackCameraLayoutOptions;
	}
}
